import { AnalyticsActionTypes } from "./constants";

const INIT_STATE = {
  data: null,
  loading: false,
};

interface AffiliatesData {
  data?: any;
}

interface AffiliatesActionType {
  type:
    | AnalyticsActionTypes.GET_ANALYTICS
    | AnalyticsActionTypes.GET_ANALYTICS_SUCCESS
    | AnalyticsActionTypes.GET_ANALYTICS_ERROR;
  payload: {
    actionType?: string;
    data?: AffiliatesData;
    error?: string;
  };
}

interface State {
  data: any;
  loading: boolean;
}

const Analytics = (
  state: State = INIT_STATE,
  action: AffiliatesActionType
): any => {
  switch (action.type) {
    case AnalyticsActionTypes.GET_ANALYTICS_SUCCESS:
      switch (action.payload.actionType) {
        case AnalyticsActionTypes.GET_ANALYTICS: {
          return {
            ...state,
            data: action.payload.data,
            loading: false,
            error: undefined,
          };
        }
        default:
          return { ...state };
      }

    case AnalyticsActionTypes.GET_ANALYTICS_ERROR:
      switch (action.payload.actionType) {
        case AnalyticsActionTypes.GET_ANALYTICS: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            data: {},
          };
        }
        default:
          return { ...state };
      }

    case AnalyticsActionTypes.GET_ANALYTICS:
      return {
        ...state,
        loading: true,
        data: {},
        error: undefined,
      };

    default:
      return { ...state };
  }
};

export default Analytics;
